import type { SvgType } from './types'

export default function Play({ fill, style, size, viewBox }: SvgType) {
  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        fillRule="evenodd"
        d="M16 32C7.17731 32 0 24.8227 0 16C0 7.17731 7.17731 0 16 0C24.8227 0 32 7.17731 32 16C32 24.8227 24.8227 32 16 32ZM16 2.78261C8.71196 2.78261 2.78261 8.71196 2.78261 16C2.78261 23.288 8.71196 29.2174 16 29.2174C23.288 29.2174 29.2174 23.288 29.2174 16C29.2174 8.71196 23.288 2.78261 16 2.78261Z"
        clipRule="evenodd"
      />
      <path
        fill={fill}
        fillRule="evenodd"
        d="M12.5217 22.2609C12.4089 22.2609 12.2962 22.2337 12.1936 22.1787C11.9674 22.0578 11.826 21.8221 11.826 21.5653V10.4348C11.826 10.178 11.9674 9.94229 12.1936 9.82137C12.4191 9.70044 12.6943 9.71471 12.9076 9.85601L21.2554 15.4212C21.449 15.5503 21.5652 15.7677 21.5652 16C21.5652 16.2324 21.449 16.4498 21.2554 16.5788L12.9076 22.1441C12.7914 22.2215 12.6569 22.2609 12.5217 22.2609Z"
        clipRule="evenodd"
      />
    </svg>
  )
}
